import GeneralEnumService from '../../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../../components/redux-form/utils/dropdown-values';
import { stringify } from 'querystring';

export const groupProgramBookEntity = (data: any) => {
    const { programMainCategories, ...res } = data;

    // Just convert to an array; the server already returns the data in the correct order
    const toArr = (v: any): any[] =>
        v ? (!Array.isArray(v) ? Object.values(v) : v) : [];

    const resData = { ...res, values: [] };
    if (data?.programMainCategories) {
        toArr(data.programMainCategories).forEach((it: any, i: number) => {
            resData.values.push({ ...it, sortOrder: i, values: [] });

            it.programCategories = toArr(it.programCategories);

            it.programCategories.forEach((it2: any, n: number) => {
                resData.values[i].values.push({ ...it2, sortOrder: n, values: [] });

                it2.programCategories = toArr(it2.programCategories);

                it2.programCategories.forEach((it3: any, v: number) => {
                    resData.values[i].values[n].values.push({
                        ...it3,
                        sortOrder: v,
                        values: [],
                    });

                    it3.programCategories = toArr(it3.programCategories);

                    it3.programCategories.forEach((it4: any, w: number) => {
                        const programTargets = toArr(it4.programTargets).map((itT: any, t: number) => {
                            const EnumSet = GeneralEnumService ? GeneralEnumService.getEnum('ProgramPrompt') : {};
                            const programPromptItems: SelectObject[] = getValFromEnum(EnumSet);

                            // let promptItem: any = '';
                            const prompts = programPromptItems.map((prompt: any) => {
                                const promptChecked = itT?.programTargetPrompts?.find(
                                    (its: any) => its.prompt == prompt.value,
                                );

                                /*if (promptChecked) {
                                    promptItem = {
                                        id: promptChecked ? promptChecked.id : false,
                                        title: prompt.label,
                                        prompt: prompt.value,
                                        checked: promptChecked ? true : false,
                                    };
                                }*/
                                return {
                                    id: promptChecked ? promptChecked.id : false,
                                    title: prompt.label,
                                    prompt: prompt.value,
                                    checked: promptChecked ? true : false,
                                };
                            });

                            return {
                                ...itT,
                                sortOrder: t,
                                dataTypeDropDown: itT.type,
                                programTargetPrompts: prompts,
                                //promptItem: promptItem,
                            };
                        });
                        resData.values[i].values[n].values[v].values.push({
                            ...it4,
                            sortOrder: w,
                            targets: programTargets,
                            values: it4.programCategories,
                        });
                    });
                });
            });
        });
    }
    return resData;
};
